import React from 'react';

// Constants
import Colors from 'Wpds/colors/ColorConstants';

// Components
import { WpCard, WpCardBody } from 'Wpds/components/card';
import { WpText } from 'Wpds/components/text';

const ColorsDocs = () => {
  const ColorRow = color => {
    const colors = Colors[color];
    return (
      <div className="pb-4">
        <h4>{color}</h4>
        <div className="d-flex">
          {Object.entries(colors).map(([key, val]) => {
            return (
              <div style={{ width: '200px' }} key={`${color}-${key}`}>
                <WpCard>
                  <WpCardBody padding={0} centered>
                    <div style={{ backgroundColor: val as string, height: '150px' }} />
                  </WpCardBody>
                  <WpCardBody>
                    <WpText tag="p" bold>
                      {color}, {key}
                    </WpText>
                    <WpText tag="p" bold>
                      Hex
                      <WpText tag="span">{val}</WpText>
                    </WpText>
                    <WpText tag="p" bold>
                      Type:
                      <WpText tag="span">
                        {color}-{key}
                      </WpText>
                    </WpText>
                  </WpCardBody>
                </WpCard>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const colorKeys = Object.keys(Colors);
  return (
    <>
      {colorKeys.map(color => {
        return (
          <div className="d-flex flex-column" key={color}>
            {ColorRow(color)}
          </div>
        );
      })}
    </>
  );
};
export default ColorsDocs;
